import { Vue } from 'vue-property-decorator';

class ListBus extends Vue {

}

export default new ListBus();
